<template>
  <div id="app">
    <router-view></router-view>

    <div
      :class="[
        'toolbar-mobile-vs',
        isActiveRoute('/videos') ? 'bg-toolbar-mobile-video border-none' : '',
        isActiveRoute('/pages/login') ||
        isActiveRoute('/pages/register') ||
        isActiveRoute('/checkout') ||
        isActiveRoute('/mobile/whatsapp-chat') ||
        isActiveRoute('/mobile/instagram-chat') ||
        isActiveRoute('/checkout/payment') ||
        isActiveRoute('/checkout/complete')
          ? 'hidden'
          : 'lg:hidden flex',
      ]"
    >
      <!-- <a
        href="#"
        :class="['toolbar-icon px-4 flex items-center justify-center', isActiveRoute('/game') ? 'toolbar-active' : '']"
      >
        <feather-icon icon="MessageSquareIcon" svg-classes="w-7 h-7 icon-color text-[#626262]" />
      </a> -->

      <div
        :class="[
          'toolbar-icon px-4 flex items-center justify-center',
          isActiveRoute('/dispositivo') ? 'toolbar-active' : '',
        ]"
        @click="navigateTo('/dispositivo')"
      >
        <feather-icon icon="GridIcon" svg-classes="w-7 h-7" />
      </div>

      <div
        :class="[
          'toolbar-icon px-4 flex items-center justify-center',
          isActiveRoute('/videos') ? 'toolbar-active' : '',
        ]"
        @click="navigateTo('/videos')"
      >
        <feather-icon icon="VideoIcon" svg-classes="w-7 h-7" />
      </div>

      <div
        :class="[
          'toolbar-icon px-4 flex items-center justify-center',
          isActiveRoute('/marketplace') ? 'toolbar-active' : '',
        ]"
        @click="navigateTo('/marketplace')"
      >
        <feather-icon icon="ShoppingCartIcon" svg-classes="w-7 h-7" />
      </div>
    </div>

    <a href="https://wa.me/551132300769?text=Detetive%2C%20preciso%20de%20ajuda!" class="wpp">
      <img src="@/assets/images/pages/whatsapp.svg" alt="Logo" style="width: 50%; height: 50%" />
    </a>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';

export default {
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    },
    // $route() {
    //   window.Tawk_API.showWidget();
    // },
  },
  methods: {
    isActiveRoute(route) {
      return this.$route.path === route;
    },
    navigateTo(route) {
      this.$router.push(route);
    },
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
  },
  mounted() {
    // if (!window.Tawk_API) {
    //   (function () {
    //     var s1 = document.createElement('script'),
    //       s0 = document.getElementsByTagName('script')[0];
    //     s1.async = true;
    //     s1.src = 'https://embed.tawk.to/678e4fd93a8427326071aaf4/1ii1ufr6s';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);
    //   })();
    // }

    this.toggleClassInBody(themeConfig.theme);
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });

    this.$store.dispatch('updateWindowWidth', window.innerWidth);

    setTimeout(() => {
      this.$EventBus.$emit('userChanged');
    }, 100);

    this.$EventBus.$on('userChanged', () => {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      if (userId && token) {
        window.Echo.connector.options.auth.headers['Authorization'] = `Bearer ${token}`;
        window.Echo.options.auth = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        window.Echo.leave(`mobile.${userId}`);
        window.Echo.private(`mobile.${userId}`).listen('MobileUpdate', (payload) => {
          if (window.location.href.indexOf('checkout') === -1) {
            this.$notification.show(
              (payload.alias || payload.device).replace(/(<([^>]+)>)/gi, ''),
              {
                body: payload.message.replace(/(<([^>]+)>)/gi, ''),
              },
              {}
            );

            this.$vs.notify({
              time: 10000,
              title: payload.alias || payload.device,
              text: payload.message,
              iconPack: 'feather',
              icon: 'icon-smartphone',
              color: 'primary',
              position: 'top-center',
            });
          }
        });
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
};
</script>

<style>
.icon-color {
  color: #626262;
}

.iconwpp {
  color: #fff;
}

.wpp {
  width: 60px;
  height: 60px;
  background-color: #4ff56b;
  border-radius: 100%;
  position: fixed;
  right: 20px;
  bottom: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
